/* eslint-disable complexity */
/* eslint-disable no-param-reassign */
/* global yaCounter994527 */

import Vue from 'vue';
import debounce from 'lodash/debounce';

const ELEMENT_TYPE_CHECKBOX = 0;

export default (context, inject) => {
	let errors = [];

	function enrichData(e, data) {
		if (!data.context) {
			data.context = {};
		}
		const ctx = data.context;

		if (typeof window !== 'undefined') {
			if (document.referrer) {
				ctx.referrer = document.referrer;
			}
			ctx.location = window.location.href;

			const clientID = typeof yaCounter994527 !== 'undefined'
				? yaCounter994527.getClientID()
				: '';
			if (clientID) {
				ctx.clientID = clientID;
			}
			if (window.UAClientID) {
				ctx.UAClientID = window.UAClientID;
			}
		}

		try {
			const responseError = context.$api.getErrorMessage(e);
			if (responseError) {
				ctx.responseError = responseError;
				const { config } = e;
				if (config) {
					ctx.baseURL = config.baseURL;
					ctx.url = config.url;
					ctx.params = config.params;

					ctx.error = data.message;
					data.message = config.url;
				}
				data.message += `: ${responseError}`;
			}
		} catch (err) {
			//
		}

		if (e.stack) {
			ctx.stack = e.stack;
		}
		if (!ctx.stack && 'captureStackTrace' in Error) {
			const error = {};
			Error.captureStackTrace(error, enrichData);
			ctx.stack = error.stack;
		}
		if (!ctx.stack) {
			const error = new Error('Stack capture');
			ctx.stack = error.stack;
		}

		if (typeof navigator !== 'undefined') {
			[
				'appCodeName',
				'appName',
				'appVersion',
				'doNotTrack',
				'cookieEnabled',
				'deviceMemory',
				'hardwareConcurrency',
				'platform',
				'product',
				'productSub',
				'userAgent',
				'userAgentData',
				'vendor',
			].forEach((key) => {
				if (navigator[key]) {
					ctx[key] = navigator[key];
				}
			});
		}

		return data;
	}

	function toBackend() {
		const entries = errors;
		errors = [];
		try {
			context.$api.axios.$post('api/log/entries', { entries }).then();
		} catch (error) {
			console.error(error);
		}
	}
	const AFTER_MS = 1000;
	const debouncedStore = debounce(toBackend, AFTER_MS);

	/**
	 * Logs all checkbox clicks with data-action
	 * @param {Event} event
	 * @returns
	 */
	function checkboxesDelegateHandler(event) {
		const { target } = event;

		const input = target.closest('input');

		if (!input) return;

		if (input.type.toLowerCase() !== 'checkbox') return;

		// get `action_name` from <input data-action="action_name">
		const { action } = target.dataset;

		if (!action) return;

		try {
			context.$api.axios.$post('api/action', {
				ts: new Date().valueOf(),
				element_type: ELEMENT_TYPE_CHECKBOX,
				id: target.id,
				checked: target.checked,
				name: target.name,
				action,
			});
		} catch (error) {
			console.error(error);
		}
	}

	const logger = {
		info(message, ctx = {}) {
			const e = enrichData({}, {
				level: 'info',
				message,
				context: {
					...ctx,
					from: 'logger',
				},
			});
			console.info(e.message);
			errors.push(e);
			debouncedStore();
		},
		warn(message, ctx = {}) {
			const e = enrichData({}, {
				level: 'warning',
				message,
				context: {
					...ctx,
					from: 'logger',
				},
			});
			console.warn(e.message);
			errors.push(e);
			debouncedStore();
		},
		error(message, ctx = {}) {
			const e = enrichData({}, {
				message,
				context: {
					...ctx,
					from: 'logger',
				},
			});
			console.error(e.message);
			errors.push(e);
			debouncedStore();
		},
		exception(e, method = '', vm = null) {
			const m = method ? `${method} ` : '';
			const msg = (vm && vm.$options) ? `${vm.$options.name}@${m}` : m;
			const err = enrichData(e, {
				message: `${msg}${e.name}: ${e.message}`,
				context: {
					from: 'logger',
				},
			});
			console.error(err.message);
			console.error(e);
			errors.push(err);
			debouncedStore();
		},
		// legacy
		log(e) {
			if (e === null) {
				return;
			}

			if (process.env.NODE_ENV !== 'production') {
				console.error(e);
			}

			if (typeof e === 'object') {
				this.exception(e);

				if (context.$sentry) {
					context.$sentry.captureException(e);
				}
				return;
			}

			if (typeof e === 'string' && context.$sentry) {
				context.$sentry.captureMessage(e);
			}
		},
	};

	inject('logger', logger);
	// eslint-disable-next-line no-param-reassign
	context.$logger = logger;

	Vue.config.errorHandler = (e, vm, info) => {
		const name = (vm && vm.$options) ? vm.$options.name : 'component';
		const err = enrichData(e, {
			message: `${name}@${info}: ${e.name}: ${e.message}`,
			context: {
				from: 'Vue.config.errorHandler',
			},
		});
		console.error(err.message);
		console.error(e);
		errors.push(err);
		debouncedStore();
	};
	Vue.config.warnHandler = (msg, vm, trace) => {
		const name = (vm && vm.$options) ? vm.$options.name : 'component';
		const e = enrichData({}, {
			level: 'warning',
			message: `${name}: ${msg}`,
			context: {
				stack: trace,
				from: 'Vue.config.warnHandler',
			},
		});
		console.warn(e.message, e.context.stack);
		errors.push(e);
		debouncedStore();
	};

	if (process.client) {
		window.onerror = function onerror(message, source, lineno, colno, error) {
			console.error(error);
			errors.push(enrichData(error, {
				message: `${error.name}: ${message}`,
				context: {
					from: 'window.onerror',
					source,
					lineno,
					colno,
				},
			}));
			debouncedStore();
		};

		document.addEventListener('change', checkboxesDelegateHandler);
	}
};
